import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from '@mui/lab';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Dialog,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  pickConsultation,
  selectFollowUpConsultationById,
} from 'FRONTEND/reducers/followUpSlice';
import i18n from 'FRONTEND/utils/i18n';

const VitalsDialog = ({ onClose, open, consultation }) => {
  const handleClose = () => {
    onClose();
  };

  return consultation && (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='flex-start'
          spacing={1}
        >
          <Stack>
            <Typography variant='h6'>
              {consultation.label}
            </Typography>
            <Typography variant='body2'>
              {consultation.date}
            </Typography>
          </Stack>
          <IconButton
            onClick={handleClose}
            edge='end'
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <List sx={{ pt: 0 }}>
        {consultation.vitals.map(v => (
          <ListItem key={`${v.label}${v.unit}`}>
            <ListItemText
              primary={v.label}
              secondary={`${v.value} ${v.unit}`}
            />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};

const ConsultationTimeline = ({
  consultationList,
}) => {
  const dispatch = useDispatch();
  const selectedConsultation = useSelector((state) => selectFollowUpConsultationById(state, state.followUp.selectedConsultationId));
  const [isExpanded, setIsExpanded] = useState(false);

  const handleConsultationClick = (consultationId) => {
    dispatch(pickConsultation({ consultationId }));
  };

  const handleClose = () => {
    dispatch(pickConsultation({ consultationId: null }));
  };

  const handleExpandChange = () => {
    setIsExpanded(!isExpanded);
  };

  if (consultationList && consultationList.length) {
    return (
      <Accordion
        expanded={isExpanded}
        onChange={handleExpandChange}
        square
        sx={{ mb: 1 }}
      >
        <AccordionSummary
          sx={{ width: '100%' }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography sx={{ width: '33%', flexShrink: 0, paddingLeft: 1 }}>
            {i18n._('Consultations')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Timeline>
            {consultationList.map((consultation) => (
              <TimelineItem
                key={consultation.id}
                onClick={() => handleConsultationClick(consultation.id)}
                sx={{ cursor: 'pointer' }}
              >
                <TimelineOppositeContent color='text.secondary'>
                  <Badge badgeContent={consultation.vitals.length} color='primary'>
                    <Typography sx={{ textDecoration: 'underline' }}>{consultation.label}</Typography>
                  </Badge>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>{consultation.date}</TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
          <VitalsDialog
            consultation={selectedConsultation}
            open={Boolean(selectedConsultation)}
            onClose={handleClose}
          />
        </AccordionDetails>
      </Accordion>
    );
  }
};

export default ConsultationTimeline;
